function isFullScreen() {
  // @ts-ignore
  return !!(document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement)
}

export function toggleFull(
  container?: HTMLElement,
  cb?: (flag: boolean) => void,
): void {
  if (isFullScreen()) {
    cb?.(true)
    if (document.exitFullscreen) document.exitFullscreen()
    // @ts-ignore
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen()
    // @ts-ignore
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen()
    // @ts-ignore
    else if (document.msExitFullscreen) document.msExitFullscreen()
  } else {
    cb?.(false)
    if (container) {
      if (container.requestFullscreen) container.requestFullscreen()
      // @ts-ignore
      else if (container.mozRequestFullScreen) container.mozRequestFullScreen()
      // @ts-ignore
      else if (container.webkitRequestFullScreen) videoRef.value?.webkitRequestFullScreen()
      // @ts-ignore
      else if (container.msRequestFullscreen) container.msRequestFullscreen()
    }
  }
}

function formatClockFromTime(duration: number) {
  const ms = Math.round(duration * 1000)
  const nowDate = new Date(0)
  nowDate.setMilliseconds(ms)
  const timeString = nowDate.toISOString()
  return duration > 3600 ? timeString.substr(11, 8) : timeString.substr(14, 5)
}

export function getCurrentDurationText(current: number, duration: number): string {
  return `${formatClockFromTime(current)} / ${formatClockFromTime(duration)}`
}
